export const leaveApprovalType = {
    APPROVED: "Approved",
    DISAPPROVED: "Disapproved"
}